/* Gardens of Vaitarna — Theme JS */

(function () {
  'use strict';

  // ── Header scroll ──
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('site-header--scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  // ── Mobile menu ──
  const hamburger = document.getElementById('hamburger-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileClose = document.getElementById('mobile-menu-close');

  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    hamburger?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    hamburger?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  hamburger?.addEventListener('click', openMenu);
  mobileClose?.addEventListener('click', closeMenu);
  mobileMenu?.addEventListener('click', (e) => { if (e.target === mobileMenu) closeMenu(); });

  // ── Scroll animations ──
  const fadeEls = document.querySelectorAll('.fade-up');
  if (fadeEls.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    fadeEls.forEach(el => io.observe(el));
  } else {
    fadeEls.forEach(el => el.classList.add('is-visible'));
  }

  // ── Announcement bar dismiss ──
  document.querySelectorAll('.announcement-bar__close').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.announcement-bar')?.remove();
    });
  });

  // ── Product gallery thumbnails ──
  const thumbs = document.querySelectorAll('.product-page__thumb');
  const mainImg = document.querySelector('.product-page__main-image img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      // Use the full-resolution URL, not the thumbnail's own (160px) src —
      // swapping in the thumbnail src here was upscaling a tiny image to
      // fill the large main-image box, causing visible pixelation.
      const fullSrc = thumb.querySelector('img')?.dataset.fullSrc;
      if (mainImg && fullSrc) {
        mainImg.removeAttribute('srcset');
        mainImg.src = fullSrc;
      }
    });
  });

  // ── Quantity controls ──
  const qtyMinus = document.querySelector('.qty-minus');
  const qtyPlus  = document.querySelector('.qty-plus');
  const qtyInput = document.querySelector('.product-page__qty-num');
  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', () => {
      const v = parseInt(qtyInput.value) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
    qtyPlus.addEventListener('click', () => {
      qtyInput.value = (parseInt(qtyInput.value) || 1) + 1;
    });
  }

  // ── Smooth scroll for anchor links ──
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

})();

/* ── CART DRAWER ── */
(function () {
  'use strict';

  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  var closeBtn = document.getElementById('cart-drawer-close');
  var content = document.getElementById('cart-drawer-content');
  if (!drawer || !content) return;

  function isDesktop() {
    return window.matchMedia('(min-width: 768px)').matches;
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function refreshDrawerContent(callback) {
    fetch('/?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var freshContent = temp.querySelector('#cart-drawer-content');
        if (freshContent) content.innerHTML = freshContent.innerHTML;
        if (callback) callback();
      });
  }

  closeBtn?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  content.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-close]')) closeDrawer();
  });

  // Quantity stepper — event delegation so it survives content refreshes
  content.addEventListener('click', function (e) {
    var minusBtn = e.target.closest('.cart-drawer__qty-btn--minus');
    var plusBtn = e.target.closest('.cart-drawer__qty-btn--plus');
    if (!minusBtn && !plusBtn) return;
    var itemEl = e.target.closest('.cart-drawer__item');
    var input = itemEl.querySelector('.cart-drawer__qty-input');
    var line = parseInt(itemEl.getAttribute('data-line'), 10);
    var v = minusBtn
      ? Math.max(1, (parseInt(input.value, 10) || 1) - 1)
      : Math.min(99, (parseInt(input.value, 10) || 1) + 1);
    changeDrawerLine(line, v, itemEl);
  });
  content.addEventListener('change', function (e) {
    if (!e.target.classList.contains('cart-drawer__qty-input')) return;
    var itemEl = e.target.closest('.cart-drawer__item');
    var line = parseInt(itemEl.getAttribute('data-line'), 10);
    var v = Math.max(0, Math.min(99, parseInt(e.target.value, 10) || 0));
    changeDrawerLine(line, v, itemEl);
  });

  function changeDrawerLine(line, quantity, itemEl) {
    itemEl?.classList.add('is-updating');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        refreshDrawerContent();
      });
  }

  // Intercept the product-page "Add to Basket" form: add via AJAX instead
  // of a full-page redirect, then open the drawer on desktop or just bump
  // the header counter on mobile.
  var addForm = document.getElementById('product-form');
  if (addForm) {
    addForm.addEventListener('submit', function (e) {
      if (e.submitter && e.submitter.name !== 'add') return; // let Buy Now's own handler run untouched
      e.preventDefault();
      var addBtn = document.getElementById('product-add-btn');
      var originalText = addBtn ? addBtn.textContent : '';
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding…'; }

      var formData = new FormData(addForm);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          if (isDesktop()) {
            refreshDrawerContent(openDrawer);
          }
        })
        .catch(function () {
          addForm.submit(); // fallback to normal redirect flow if AJAX fails
        })
        .finally(function () {
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = originalText; }
        });
    });
  }

  // Header cart icon: open the drawer on desktop, navigate normally on mobile
  document.querySelectorAll('[data-cart-icon]').forEach(function (icon) {
    icon.addEventListener('click', function (e) {
      if (isDesktop()) {
        e.preventDefault();
        refreshDrawerContent(openDrawer);
      }
    });
  });
})();
